import {
  medigiLanding,
  medshortsLanding,
  outsourcingLanding,
} from 'src/app/shared/models/landing';
import { defaultSupplierConfig } from 'src/environments/hydra/configs';
import { hydraSupplierConfigMap } from 'src/environments/hydra/config.map';

const _domain = 'gpr-production.medigi.com';

const supplierConfig =
  window.location.host in hydraSupplierConfigMap
    ? hydraSupplierConfigMap[window.location.host]
    : (_domain in hydraSupplierConfigMap
      ? hydraSupplierConfigMap[_domain]
      : defaultSupplierConfig);

const baseURL = 'https://gpr-production-api.medigi.com';

export const environment = {
  production: false,
  env_name: 'production',
  domain: _domain,
  url: 'https://gpr-production.medigi.com',
  api_url_v1: baseURL,
  api_url_v2: baseURL,
  singleton_service_url: 'https://default-production-api.medigi.com',
  medshorts_url: 'https://staging.medshorts.com',
  flower_url: 'http://localhost:8081/misc/flower/dashboard',
  health_url: 'http://localhost:8081/misc/health',
  auth_url: `${baseURL}/auth`,
  auth_url_login: `${baseURL}/auth/login`,
  proxy_url: 'http://localhost:8081/misc/proxy',
  express222Form: 'asdf',
  gatag: undefined,
  clientDomains: {
    outsourcingDomian: 'gpr-production-503b.medigi.com',
    medigiDomain: 'gpr-production.medigi.com',
    medshortsDomain: '',
    cgtDomain: '',
  },
  availableThemes: {
    'gpr-production.medigi.com': medigiLanding,
  },
  catalogType: {
    'gpr-production.medigi.com': 'medigi',
  },
  customLogoutURL: undefined,
  auth0: {
    clientId: 'F97RYlAyyMVwNpoYRBSqSKa9U6dgqLON',
    domain: 'hydraprod.us.auth0.com',
    apiIdentifier: 'https://hydraprod.us.auth0.com/api/v2/',
    appMetadata: 'http://hydraprod.com/api/app_metadata',
    userMetadata: 'http://hydraprod.com/api/user_metadata',
    supplierHostMap: {},
  },
  sentry: {
    dsn: undefined,
  },
  posthog: {
    apiKey: 'phc_5EifUXpnbOAd7ZM3nnQYFsf3nNRufuU2bIElQVuGMOT',
    apiHost: 'https://us.i.posthog.com',
    enabled: true,
    autocapture: true,
    capture_pageview: true,
    session_recording: {
      enabled: true,
      maskAllInputs: true,
      maskTextSelector: '.sensitive, .phi, .pii',
    },
  },
  legisym_url: 'https://demo.dev.express222.com/prompt.php',
  supplierConfig: supplierConfig,
};
